webpackJsonp([0],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1BaB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"text-center"},[_c('b',[_vm._v("Personal Data Privacy and Protection")])]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Your responses to this questionnaire will be stored on a secure server managed by Google. All your personal information will be encrypted using 256 BIT AES Encryption Algorithm and anonymized. Your personal information will not be shared with any third parties. You can request that your data be deleted from the server at any time.")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('p',{staticClass:"text-center"},[_c('b',[_vm._v("Research Version")])]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("The current version of this instrument is a research version. It is currently being tested for reliability and\nvalidity. Until this process is complete: 1) we cannot predict that your results would be the same if you\ncompleted the instrument again in the future; 2) we cannot claim that your results are related to any\nother outcome such as occupational performance. However, your personalized report will provide rich\nobservations about your behavior in terms of the t 3 model. We thank you for helping to create the fully\ntested and validated instrument.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2DgM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pair_vue__ = __webpack_require__("hqSQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_422019b9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pair_vue__ = __webpack_require__("sCQA");
function injectStyle (ssrContext) {
  __webpack_require__("XlxS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-422019b9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pair_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_422019b9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pair_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3lvq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.dcb6e42.png";

/***/ }),

/***/ "9I4D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(!_vm.isIE)?_c('div',[_c('h1',[_vm._v("Welcome!")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Please enter the access code to proceed.")]),_vm._v(" "),_c('form',{on:{"submit":_vm.validateCode}},[_c('div',{staticClass:"form-group row "},[_c('div',{staticClass:"col-md-4 mx-auto"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.access_code),expression:"access_code"}],staticClass:"form-control",attrs:{"type":"text","id":"inputBox","required":"","name":"code","placeholder":"Access Code"},domProps:{"value":(_vm.access_code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.access_code=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],staticClass:"input-text text-danger"},[_vm._v("Invalid Access code.")])])]),_vm._v(" "),_c('div',{staticClass:"form-group row "},[_c('div',{staticClass:"col-md-4 mx-auto"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control",attrs:{"type":"email","id":"inputBox","required":"","name":"email","placeholder":"Email Address"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_vm._m(0)])]):_vm._e(),_vm._v(" "),(_vm.isIE)?_c('div',[_c('h3',[_vm._v("Browser Not Supported.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Please try to open it using these supported browsers.")]),_vm._v(" "),_vm._m(1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group row "},[_c('div',{staticClass:"col-md-3 mx-auto"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"submit"}},[_vm._v("Next")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group"},[_c('li',{staticClass:"list-group-item"},[_vm._v("Firefox")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_vm._v("Chrome")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_vm._v("Safari")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_vm._v("Opera")]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_vm._v("Microsoft Edge")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fg2g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report"},[_c('h3',[_vm._v("Survey Completed!")]),_vm._v(" "),_c('p',[_vm._v("You have successfuly completed the survey.The report has been emailed to you. Please check your email to download your results. ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.emailReport}},[_vm._v("Re-send Email")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":_vm.downloadReport}},[_vm._v("Download Report")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var apiUrl = 'https://t3.talkingtowardtruth.org/api/';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Home',

    data: function data() {
        return {
            error: false,
            access_code: null,
            email: null,
            isIE: false
        };
    },

    methods: {
        validateCode: function validateCode(e) {
            var _this = this;

            e.preventDefault();

            this.$http.post(apiUrl + 'validate', {
                token: this.access_code,
                email: this.email
            }).then(function (response) {
                if (response.body.token !== 0) {
                    _this.$cookie.set('token', response.body.token);
                    _this.$cookie.set('email', _this.email);

                    if (response.body.user_id) {
                        _this.$cookie.set('user_id', response.body.user_id);
                    }
                    _this.$router.push('start');
                } else {
                    _this.error = true;
                }
            }, function (error) {
                console.log(error);
                _this.error = true;
            });
        },

        GetIEVersion: function GetIEVersion() {
            var sAgent = window.navigator.userAgent;
            var Idx = sAgent.indexOf("MSIE");

            // If IE, return version number.
            if (Idx > 0) return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));

            // If IE 11 then look for Updated user agent string.
            else if (!!navigator.userAgent.match(/Trident\/7\./)) return 11;else return 0; //It is not IE
        }
    },
    created: function created() {
        // this.$cookie.delete('user_id')
        var token = this.$cookie.get('token');
        if (token) {
            this.$router.push('start');
        } else {
            console.log('No token used');
        }
        if (this.GetIEVersion() > 0) this.isIE = true;else {
            this.isIE = false;
        }
    }
});

/***/ }),

/***/ "If62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[(_vm.showQ)?_c('div',[_c('Pair')],1):_vm._e(),_vm._v(" "),(_vm.showTerms)?_c('div',[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[_c('h3',[_vm._v("Instructions:")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":"/static/pair.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":_vm.acceptTerms}},[_vm._v("Agree & Start Survey")])])])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showQ && !_vm.showTerms),expression:"!showQ && !showTerms"}]},[_c('form',{on:{"submit":_vm.acceptUser}},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-6  text-left",attrs:{"id":"infoBox"}},[_c('h4',{staticClass:"text-primary"},[_vm._v("Your Information:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.info.email),expression:"info.email"}],staticClass:"form-control",attrs:{"type":"email","readonly":"","placeholder":"Email","required":""},domProps:{"value":(_vm.info.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.info.email=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.info.age),expression:"info.age"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"Age","max":"120","required":""},domProps:{"value":(_vm.info.age)},on:{"input":function($event){if($event.target.composing){ return; }_vm.info.age=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.info.gender),expression:"info.gender"}],staticClass:"form-control",attrs:{"name":"","id":"","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.info.gender=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Select")]),_vm._v(" "),_c('option',{attrs:{"value":"M"}},[_vm._v("Male")]),_vm._v(" "),_c('option',{attrs:{"value":"F"}},[_vm._v("Female")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.info.occupation),expression:"info.occupation"}],staticClass:"form-control",attrs:{"name":"","id":"","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.info.occupation=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.industries),function(industry){return _c('option',{domProps:{"value":industry.value}},[_vm._v(_vm._s(industry.value))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.info.role),expression:"info.role"}],staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.info.role=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.roles),function(role){return _c('option',{domProps:{"value":role.value}},[_vm._v(_vm._s(role.value))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.info.education),expression:"info.education"}],staticClass:"form-control",attrs:{"name":"","id":"","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.info.education=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Choose Highest Education Level Attained")]),_vm._v(" "),_vm._l((_vm.educations),function(edu){return _c('option',{domProps:{"value":edu.value}},[_vm._v(_vm._s(edu.value))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.info.nationality),expression:"info.nationality"}],staticClass:"form-control",attrs:{"name":"","id":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.info.nationality=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","disabled":""}},[_vm._v("Select")]),_vm._v(" "),_vm._l((_vm.nationalities),function(nation){return _c('option',{domProps:{"value":nation.value}},[_vm._v(_vm._s(nation.value))])})],2)])])]),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(9)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"text-left"},[_c('li',[_vm._v("First choose the item in the column that is more like you.")]),_vm._v(" "),_c('li',[_vm._v("Then rate how much it is like you from 1 - 7 with 7 the highest rating you can give.")]),_vm._v(" "),_c('li',[_vm._v("Both choices may feel like you; choose and rate the strongest choice. You will choose the column and rate your choice on every page of the survey to follow.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Email Address:"),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Age:"),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Gender:"),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Industry of occupation:"),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Role in organization:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Level of education:"),_c('span',{staticClass:"text-danger"},[_vm._v("*")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('label',{attrs:{"for":""}},[_vm._v("Preferred Nationality:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-4 text-left"},[_c('h4',{staticClass:"text-danger"},[_vm._v("Instructions:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('ul',[_c('li',[_c('span',{staticClass:"text-danger"},[_vm._v("*")]),_vm._v(" Required fields.")]),_vm._v(" "),_c('li',[_vm._v("We will never share your information.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group row"},[_c('div',{staticClass:"col-sm-3"}),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"type":"submit"}},[_vm._v("Next")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ImpT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25441132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Vq/C");
function injectStyle (ssrContext) {
  __webpack_require__("WpCr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25441132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MW4G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Terms',

  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
  }
});

/***/ }),

/***/ "SWmq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("UthT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f5ee3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("1BaB");
function injectStyle (ssrContext) {
  __webpack_require__("ikP5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01f5ee3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f5ee3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tpll":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UthT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FooterBox',

  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "Vq/C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":__webpack_require__("7Otq")}}),_vm._v(" "),_c('div',{attrs:{"transition":"fadeInUpBig"}},[_c('router-view'),_vm._v(" "),_c('br'),_vm._v(" "),_c('FooterBox')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WpCr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XlxS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__("sCSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie__ = __webpack_require__("K/Lq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Question__ = __webpack_require__("d5Sz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Instruction__ = __webpack_require__("mg6j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Report__ = __webpack_require__("dc43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_animate_dist_vue_animate_min_css__ = __webpack_require__("ImpT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_animate_dist_vue_animate_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_animate_dist_vue_animate_min_css__);















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Home__["a" /* default */]
  }, {
    path: '/start',
    name: 'Start',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Question__["a" /* default */]
  }, {
    path: '/terms',
    name: 'Terms',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Instruction__["a" /* default */]
  }, {
    path: '/results',
    name: 'Results',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Report__["a" /* default */]
  }]
}));

/***/ }),

/***/ "d5Sz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__ = __webpack_require__("eE7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90fadd76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__ = __webpack_require__("If62");
function injectStyle (ssrContext) {
  __webpack_require__("Tpll")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-90fadd76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_90fadd76_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dc43":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__ = __webpack_require__("ybql");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20681953_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__ = __webpack_require__("Fg2g");
function injectStyle (ssrContext) {
  __webpack_require__("SWmq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20681953"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Report_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20681953_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Report_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eE7u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pair__ = __webpack_require__("2DgM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Instruction__ = __webpack_require__("mg6j");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var apiUrl = 'https://t3.talkingtowardtruth.org/api/';
var user = true;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Question',
  components: {
    Pair: __WEBPACK_IMPORTED_MODULE_0__Pair__["a" /* default */], Terms: __WEBPACK_IMPORTED_MODULE_1__Instruction__["a" /* default */]
  },
  data: function data() {
    return {
      showQ: false,
      showTerms: false,
      educations: [],
      industries: [],
      roles: [],
      nationalities: [],
      info: {
        email: this.$cookie.get('email'),
        age: null,
        gender: '',
        occupation: '',
        role: '',
        education: '',
        nationality: ''
      }
    };
  },

  methods: {
    acceptUser: function acceptUser(e) {
      var _this = this;

      e.preventDefault();
      var token = this.$cookie.get('token');
      console.log(this.info);
      this.$http.post(apiUrl + 'user_info/' + token, this.info).then(function (response) {
        console.log(response.body);
        if (response.body.userid) {
          _this.$cookie.set('user_id', response.body.userid);
          _this.showTerms = true;
        } else {
          console.log(response.body);
        }
      }, function (error) {
        console.log(error);
      });
    },
    acceptTerms: function acceptTerms() {
      this.showTerms = false;
      this.showQ = true;
    },
    loadDropdowns: function loadDropdowns() {
      this.loadEducations();
      this.loadIndustries();
      this.loadNationalities();
      this.loadRoles();
    },

    loadEducations: function loadEducations() {
      var _this2 = this;

      this.$http.get(apiUrl + 'educations').then(function (response) {
        _this2.educations = response.body;
      }, function (error) {
        console.log(error);
      });
    },
    loadIndustries: function loadIndustries() {
      var _this3 = this;

      this.$http.get(apiUrl + 'industries').then(function (response) {
        _this3.industries = response.body;
      }, function (error) {
        console.log(error);
      });
    },
    loadNationalities: function loadNationalities() {
      var _this4 = this;

      this.$http.get(apiUrl + 'nationalities').then(function (response) {
        _this4.nationalities = response.body;
      }, function (error) {
        console.log(error);
      });
    },
    loadRoles: function loadRoles() {
      var _this5 = this;

      this.$http.get(apiUrl + 'roles').then(function (response) {
        _this5.roles = response.body;
      }, function (error) {
        console.log(error);
      });
    }
  },
  created: function created() {
    this.loadDropdowns();
    var token = this.$cookie.get('token');
    console.log(token);
    if (token) {
      if (this.$cookie.get('user_id')) {
        this.showQ = true;
      } else {
        this.showQ = false;
      }
    } else {
      console.log('no token found');
      this.$router.push('');
    }
  }
});

/***/ }),

/***/ "hqSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var apiUrl = 'https://t3.talkingtowardtruth.org/api/';
var used_id = 0;
var scoreData = {};
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Pair',

    data: function data() {
        return {
            form: {
                score: null
            },
            attempted: 0,
            total: 0,
            questionData: {
                q1: '',
                q2: ''
            }
        };
    },

    methods: {
        onSubmit: function onSubmit(e) {
            e.preventDefault();
            var user_id = this.$cookie.get('user_id');
            if (this.form.score > 7) {
                scoreData = {
                    question_id: this.questionData.q2_id,
                    user_id: user_id,
                    pair_id: this.questionData.pair_id,
                    score: this.form.score - 7
                };
            } else {
                scoreData = {
                    question_id: this.questionData.q1_id,
                    user_id: user_id,
                    pair_id: this.questionData.pair_id,
                    score: this.form.score
                };
            }
            console.log(scoreData);
            this.postScore(scoreData);
        },
        getPair: function getPair() {
            var _this = this;

            console.log('Getting Pair');
            this.getAttempted();
            var user_id = this.$cookie.get('user_id');

            this.$http.get(apiUrl + 'pair/random/' + user_id).then(function (response) {

                _this.questionData = response.body;
                if (response.body) {
                    _this.postAttempt({
                        user_id: _this.$cookie.get('user_id'),
                        pair_id: response.body.pair_id
                    });
                }

                if (!response.body) {
                    _this.$router.push('results');
                    if (!_this.$cookie.get('sent')) {
                        _this.emailReport();
                        _this.$cookie.set('sent', 'true');
                    }
                }
            }, function (error) {
                console.log(error);
            });
        },
        getTotal: function getTotal() {
            var _this2 = this;

            this.$http.get(apiUrl + 'pair_count').then(function (response) {
                _this2.total = response.body.count;
            }, function (error) {});
        },
        getAttempted: function getAttempted() {
            var _this3 = this;

            var user_id = this.$cookie.get('user_id');
            this.$http.get(apiUrl + 'attempted_count/' + user_id).then(function (response) {
                _this3.attempted = response.body.count;
            }, function (error) {});
        },
        checkFailedAttempt: function checkFailedAttempt() {
            var _this4 = this;

            var user_id = this.$cookie.get('user_id');

            this.$http.get(apiUrl + 'attempt/failed/' + user_id + '/all').then(function (response) {
                if (response.body) {
                    var pair_id = response.body.pair_id;
                    _this4.$http.get(apiUrl + 'pair/' + pair_id).then(function (response) {

                        _this4.questionData = response.body;
                        if (!response.body) {
                            _this4.getPair();
                        }
                    }, function (error) {
                        console.log(error);
                    });
                } else {
                    _this4.getPair();
                }
            });
            this.getAttempted();
        },
        postAttempt: function postAttempt(data) {

            this.$http.post(apiUrl + 'attempt', data).then(function (response) {
                console.log('Un answered attempt posted');
            }, function (error) {});
        },
        updateAttemptStatus: function updateAttemptStatus() {
            var pair_id = this.questionData.pair_id;
            var user_id = this.$cookie.get('user_id');

            this.$http.put(apiUrl + 'attempt/' + user_id + '/' + pair_id, {
                status: 'Y'
            }).then(function (response) {
                console.log('attempt updated');
            }, function (error) {});
        },
        postScore: function postScore(score) {
            var _this5 = this;

            this.$http.post(apiUrl + 'score', score).then(function (response) {
                _this5.form = {
                    score: null
                };
                _this5.getPair();
                _this5.updateAttemptStatus();
            }, function (error) {
                location.reload(true);
            });
        },

        emailReport: function emailReport() {
            var user_id = this.$cookie.get('user_id');
            this.$http.get(apiUrl + 'email/' + user_id).then(function (response) {
                var filename = response.body.filename;
                // alert('Email is sent!');
            }, function (error) {});
        }
    },
    created: function created() {
        this.getTotal();
        this.checkFailedAttempt();
    }
});

/***/ }),

/***/ "ikP5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j+to":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instruction"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_246bbd84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("9I4D");
function injectStyle (ssrContext) {
  __webpack_require__("uWqz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-246bbd84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_246bbd84_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mg6j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Instruction_vue__ = __webpack_require__("MW4G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4494f8ff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Instruction_vue__ = __webpack_require__("j+to");
function injectStyle (ssrContext) {
  __webpack_require__("3lvq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4494f8ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Instruction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4494f8ff_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Instruction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sCQA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pair"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-10"},[_c('b-progress',{staticClass:"mb-3",attrs:{"value":_vm.attempted,"max":_vm.total,"variant":"success"}}),_vm._v(" "),_vm._m(0)],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-5"},[_c('h4',[_vm._v("COLUMN A")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.questionData.q1))]),_vm._v(" "),_c('div',{staticClass:"score-box"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.score),expression:"form.score"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"score","value":"1"},domProps:{"checked":_vm._q(_vm.form.score,"1")},on:{"__c":function($event){_vm.form.score="1"}}}),_vm._v(" 1\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.score),expression:"form.score"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"score","value":"2"},domProps:{"checked":_vm._q(_vm.form.score,"2")},on:{"__c":function($event){_vm.form.score="2"}}}),_vm._v(" 2\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.score),expression:"form.score"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"score","value":"3"},domProps:{"checked":_vm._q(_vm.form.score,"3")},on:{"__c":function($event){_vm.form.score="3"}}}),_vm._v(" 3\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.score),expression:"form.score"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"score","value":"4"},domProps:{"checked":_vm._q(_vm.form.score,"4")},on:{"__c":function($event){_vm.form.score="4"}}}),_vm._v(" 4\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.score),expression:"form.score"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"score","value":"5"},domProps:{"checked":_vm._q(_vm.form.score,"5")},on:{"__c":function($event){_vm.form.score="5"}}}),_vm._v(" 5\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.score),expression:"form.score"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"score","value":"6"},domProps:{"checked":_vm._q(_vm.form.score,"6")},on:{"__c":function($event){_vm.form.score="6"}}}),_vm._v(" 6\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.score),expression:"form.score"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"score","value":"7"},domProps:{"checked":_vm._q(_vm.form.score,"7")},on:{"__c":function($event){_vm.form.score="7"}}}),_vm._v(" 7\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"width-100"}),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('h4',[_vm._v("COLUMN B")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.questionData.q2))]),_vm._v(" "),_c('div',{staticClass:"score-box"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.score),expression:"form.score"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"score","value":"8"},domProps:{"checked":_vm._q(_vm.form.score,"8")},on:{"__c":function($event){_vm.form.score="8"}}}),_vm._v(" 1\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.score),expression:"form.score"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"score","value":"9"},domProps:{"checked":_vm._q(_vm.form.score,"9")},on:{"__c":function($event){_vm.form.score="9"}}}),_vm._v(" 2\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.score),expression:"form.score"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"score","value":"10"},domProps:{"checked":_vm._q(_vm.form.score,"10")},on:{"__c":function($event){_vm.form.score="10"}}}),_vm._v(" 3\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.score),expression:"form.score"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"score","value":"11"},domProps:{"checked":_vm._q(_vm.form.score,"11")},on:{"__c":function($event){_vm.form.score="11"}}}),_vm._v(" 4\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.score),expression:"form.score"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"score","value":"12"},domProps:{"checked":_vm._q(_vm.form.score,"12")},on:{"__c":function($event){_vm.form.score="12"}}}),_vm._v(" 5\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.score),expression:"form.score"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"score","value":"13"},domProps:{"checked":_vm._q(_vm.form.score,"13")},on:{"__c":function($event){_vm.form.score="13"}}}),_vm._v(" 6\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.score),expression:"form.score"}],staticClass:"form-check-input",attrs:{"type":"radio","name":"score","value":"14"},domProps:{"checked":_vm._q(_vm.form.score,"14")},on:{"__c":function($event){_vm.form.score="14"}}}),_vm._v(" 7\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"width-100"}),_vm._v(" "),_vm._m(5)])])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-3"},[_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit","disabled":_vm.form.score == null}},[_vm._v("Continue")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"inst"}},[_c('p',[_vm._v("Instructions")]),_vm._v(" "),_c('ol',{staticClass:"text-left"},[_c('li',[_vm._v("First choose the item in the column that is more like you.")]),_vm._v(" "),_c('li',[_vm._v("Then rate how much it is like you from 1 - 7 with 7 the highest rating you can give.")]),_vm._v(" "),_c('li',[_vm._v("Both choices may feel like you; choose and rate the strongest choice. You will choose the column and rate your choice on every page of the survey to follow.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Rating")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('p',{staticClass:"float-left",staticStyle:{"margin-left":"10%","margin-bottom":"0","font-size":"14px"}},[_vm._v("Lowest")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('p',{staticClass:"float-right",staticStyle:{"margin-right":"10%","margin-bottom":"0","font-size":"14px"}},[_vm._v("Highest")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2"},[_c('h3',[_vm._v("OR")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("Rating")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('p',{staticClass:"float-left",staticStyle:{"margin-left":"10%","margin-bottom":"0","font-size":"14px"}},[_vm._v("Lowest")])]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('p',{staticClass:"float-right",staticStyle:{"margin-right":"10%","margin-bottom":"0","font-size":"14px"}},[_vm._v("Highest")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uWqz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__("TVmP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var apiUrl = 'http://survey.dev.asyncsofttech.com/';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: { FooterBox: __WEBPACK_IMPORTED_MODULE_0__components_Footer__["a" /* default */] }
});

/***/ }),

/***/ "ybql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

var apiUrl = 'https://t3.talkingtowardtruth.org/api/';

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Report',

  data: function data() {
    return {};
  },

  methods: {
    downloadReport: function downloadReport(e) {
      var user_id = this.$cookie.get('user_id');
      this.$http.get(apiUrl + 'report/' + user_id).then(function (response) {
        var filename = response.body.filename;
        e.preventDefault();

        window.open('https://t3.talkingtowardtruth.org/reports/' + filename, '_blank');
        // window.location.href = 'https://t3.talkingtowardtruth.org/reports/'+filename;
      }, function (error) {});
    },
    emailReport: function emailReport() {
      var user_id = this.$cookie.get('user_id');
      this.$http.get(apiUrl + 'email/' + user_id).then(function (response) {
        var filename = response.body.filename;
        alert('Email is sent!');
      }, function (error) {});
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.da4fc2b94f6a2f2b7a56.js